/**
 * Capture the page URL as early as possible so we can open the modal from hash params
 * after redirect. Must be imported first in the entry point so it runs before any code
 * (e.g. Webflow) can strip the hash. Uses top frame when in a same-origin iframe.
 */
if (typeof window !== 'undefined') {
  let search = window.location.search;
  let hash = window.location.hash;
  try {
    const top = window.top;
    if (top && top !== window && top.location.hash) {
      search = top.location.search;
      hash = top.location.hash;
    }
  } catch {
    // Cross-origin: keep our frame's URL
  }
  (window as any).__ondiem_initial_url = { search, hash };
}
